// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"style_fadeIn__1CAqX"};